<template>
  <div>
    <!-- 查询条件 -->
    <el-row gutter={10}>
      <el-col :span="6">
        <el-input
            v-model="searchParams.userName"
            placeholder="请输入用户名"
            clearable>
        </el-input>
      </el-col>
      <el-col :span="6">
        <el-input
            v-model="searchParams.phone"
            placeholder="请输入手机号"
            clearable>
        </el-input>
      </el-col>
      <el-col :span="6">
        <el-select
            v-model="searchParams.inspectorName"
            placeholder="所属检测员"
            clearable
            filterable
            :filter-method="filterInspector"
            @clear="handleInspectorClear"
            :popper-class="inspectorSearch ? '' : 'inspector-dropdown-hidden'"
            style="width: 100%">
          <el-option
              v-for="item in filteredInspectorList"
              :key="item.inspectorId"
              :label="item.nickName"
              :value="item.nickName">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <br>
    <!-- 查询按钮 -->
    <div class="block">
      <el-button type="primary" @click="searchCustomers">查询客户</el-button>
      <el-button type="success" @click="showAddCustomerDialog">新增客户</el-button>
      <el-button type="info" @click="showInviteDialog">邀请检测员</el-button>
    </div>

    <br>

    <!-- 客户列表 -->
    <el-table :data="customers" style="width: 100%">
      <el-table-column type="index" label="序号" width="80"></el-table-column>
      <el-table-column
          prop="userName"
          label="用户名"
          width="180">
      </el-table-column>
      <el-table-column
          prop="phone"
          label="手机号"
          width="180">
      </el-table-column>
      <el-table-column
          prop="inspectorName"
          label="检测员"
          width="180">
      </el-table-column>
      <el-table-column label="状态" width="100">
        <template v-slot="scope">
          <el-tag v-if="scope.row.deleted === 0" type="success" size="small">正常</el-tag>
          <el-tag v-else type="danger" size="small">已删除</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template v-slot="scope">
          <el-button size="mini" @click="editCustomer(scope.row.customerId)">修改</el-button>
          <el-button size="mini" type="danger" @click="removeCustomer(scope.row.customerId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <br><br>
    <!-- 分页控制 -->
    <div class="block">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageParams.total"
          :current-page="pageParams.current"
          :page-size="pageParams.pageSize">
      </el-pagination>
    </div>

    <!-- 新增客户对话框 -->
    <el-dialog title="新增客户" v-model="addCustomerDialogVisible">
      <el-form :model="newCustomerForm" ref="newCustomerForm" label-width="100px">
        <el-form-item label="客户姓名" :rules="[{ required: true, message: '请输入客户姓名', trigger: 'blur' }]">
          <el-input v-model="newCustomerForm.name" placeholder="请输入客户姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="newCustomerForm.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addCustomerDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="createCustomer">确定</el-button>
      </div>
    </el-dialog>

    <!-- 邀请客户对话框2.0 -->
    <el-dialog title="邀请检测员" v-model="inviteDialogVisible">
      <el-form :model="inviteForm" ref="inviteFormRef" label-width="100px">
        <el-form-item label="手机号" :rules="[{ required: true, message: '请输入客户手机号', trigger: 'blur' }]">
          <el-input v-model="inviteForm.phone" placeholder="请输入客户手机号"></el-input>
        </el-form-item>
        <el-form-item label="密码" :rules="[{ required: true, message: '请输入密码', trigger: 'blur' }]">
          <el-input v-model="inviteForm.password" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="inviteDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleInviteCustomer">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {fetchCustomers, addCustomer, updateCustomer, deleteCustomer, inviteCustomer, inviteInspector} from '@/api/user';
import {fetchInspectors} from '@/api/inspector';

export default {
  data() {
    return {
      customers: [],
      searchParams: {
        userName: '',
        phone: '',
        inspectorName: '',
        current: 1,
        pageSize: 10,
      },
      inspectorList: [],
      inspectorSearch: '', // 检测员输入框的搜索关键字
      pageParams: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      newCustomerForm: {
        name: "", // 客户姓名
        phone: "", // 客户手机号
      },
      addCustomerDialogVisible: false,
      inviteDialogVisible: false, // 邀请对话框状态

      //邀请2.0
      inviteDialogVisible: false,
      inviteLoading: false,
      inviteForm: {
        phone: '',
        password: ''
      },
      inviteRules: {
        phone: [
          { required: true, message: '手机号不能为空', trigger: 'blur' },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '请输入有效的手机号码',
            trigger: 'blur'
          }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度6-20位', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    filteredInspectorList() {
      if (!this.inspectorSearch) {
        return []; // 未输入关键字时隐藏下拉列表
      }
      const keyword = this.inspectorSearch.toLowerCase();
      return this.inspectorList.filter(item =>
        item.nickName && item.nickName.toLowerCase().includes(keyword)
      );
    }
  },
  mounted() {
    this.loadInspectorList();
  },
  methods: {
    async loadInspectorList() {
      try {
        const res = await fetchInspectors({ current: 1, pageSize: 999 });
        if (res.code === 200) {
          this.inspectorList = res.data.records || [];
        }
      } catch (e) {
        console.error('加载检测员列表失败', e);
      }
    },
    filterInspector(value) {
      this.inspectorSearch = value;
    },
    handleInspectorClear() {
      this.inspectorSearch = '';
      this.searchParams.inspectorName = '';
    },
    // 查询客户列表
    async searchCustomers() {
      const payload = {
        userName: this.searchParams.userName || undefined,
        phone: this.searchParams.phone || undefined,
        inspectorName: this.searchParams.inspectorName || undefined,
        current: this.pageParams.current,
        pageSize: this.pageParams.pageSize,
      };
      try {
        const response = await fetchCustomers(payload);
        if (response.code === 200) {
          this.customers = response.data.records;
          this.pageParams.total = response.data.total;
        } else {
          alert(response.msg || "加载客户列表失败");
        }
      } catch (error) {
        console.error("加载客户列表失败:", error);
        alert("加载客户列表失败，请稍后重试");
      }
    },
    // 分页大小变化
    handleSizeChange(val) {
      this.pageParams.pageSize = val;
      this.searchCustomers();
    },
    // 当前页变化
    handleCurrentChange(val) {
      this.pageParams.current = val;
      this.searchCustomers();
    },
    // 新增客户
    async createCustomer() {
      if (!this.newCustomerForm.name.trim()) {
        alert("客户姓名不能为空");
        return;
      }

      const payload = {
        name: this.newCustomerForm.name.trim(),
        phone: this.newCustomerForm.phone || "", // 如果未填写手机号，设置为空字符串
      };

      try {
        const response = await addCustomer(payload);
        if (response.code === 200) {
          alert("客户添加成功");
          this.addCustomerDialogVisible = false;
          this.newCustomerForm = { name: "", phone: "" }; // 重置表单
          this.searchCustomers(); // 刷新客户列表
        } else {
          alert(response.msg || "新增客户失败，请稍后再试");
        }
      } catch (error) {
        console.error("新增客户失败:", error);
        alert("新增客户失败，请稍后重试");
      }
    },
    // 编辑客户
    async editCustomer(id) {
      const input = prompt("请输入新的客户名称");
      if (input === null) return;
      const newName = input.trim();
      if (!newName) {
        alert("请输入有效的客户名称");
        return;
      }
      try {
        const response = await updateCustomer({ customerId: id, name: newName });
        if (response.code === 200) {
          this.searchCustomers();
        } else {
          alert(response.msg || "修改客户失败");
        }
      } catch (error) {
        console.error("修改客户失败:", error);
        alert("修改客户失败，请稍后重试");
      }
    },
    // 删除客户
    async removeCustomer(id) {
      if (!confirm("确认删除该客户？")) return;
      try {
        const response = await deleteCustomer(id);
        if (response.code === 200) {
          this.searchCustomers();
        } else {
          alert(response.msg || "删除客户失败");
        }
      } catch (error) {
        console.error("删除客户失败:", error);
        alert("删除客户失败，请稍后重试");
      }
    },
    // 显示新增客户对话框
    showAddCustomerDialog() {
      this.addCustomerDialogVisible = true;
    },

    // 显示邀请检测员对话框1.0
/*    showInviteDialog() {
      this.inviteDialogVisible = true;
      this.inviteForm = { phone: '', password: '' }; // 重置表单
      if (this.$refs.inviteFormRef) {
        this.$refs.inviteFormRef.resetFields(); // 重置表单验证状态
      }
    },*/

    // 显示邀请检测员对话框2.0
    showInviteDialog() {
      this.inviteDialogVisible = true
      this.resetForm()
    },

    // 重置表单
    resetForm() {
      this.inviteForm = { phone: '', password: '' }
      if (this.$refs.inviteFormRef) {
        this.$refs.inviteFormRef.resetFields()
      }
    },

    // 处理邀请检测员
    // 提交邀请请求2.0
    async handleInviteSubmit() {
      try {
        // 1. 表单验证
        await this.$refs.inviteFormRef.validate();

        // 2. 显示加载状态
        this.inviteLoading = true;

        // 3. 发送请求（使用你的接口路径）
        const { data: res } = await inviteInspector(this.inviteForm);

        // 4. 处理响应
        if (res.code === 200) { // 根据后端实际返回类型判断
          this.$message.success(res.msg || '邀请成功');
          this.inviteDialogVisible = false;
          this.searchCustomers(); // 如果需要刷新列表
        } else {
          this.$message.warning(res.msg || '操作失败');
        }
      } catch (error) {
        // 5. 统一错误处理
        if (error.response) {
          this.$message.error(`请求失败：${error.response.data.msg}`);
        } else if (error.message.includes('validate')) {
          // 忽略表单验证错误（ElementUI已提示）
        } else {
          this.$message.error('操作失败，请检查网络');
        }
      } finally {
        // 6. 重置状态
        this.inviteLoading = false;
      }
    }
  },
};
</script>

<style scoped>
.inspector-dropdown-hidden {
  display: none;
}
</style>
